// © 2015-2021 WDNA - All Rights Reserved

import * as React from 'react';
import _ from 'lodash';

import { UserDO } from 'wdna-components';
import { WidgetGrid, JarvisWidget } from 'wdna-components/lib';

import { config } from '../../../../config/config';

const Iframe = (props: { src: string; }): JSX.Element => {
  return (
    <div className="iframe-container">
      <iframe title="iframe" src={props.src} scrolling="no" style={{ overflow: 'hidden' }} allowFullScreen />
    </div>
  );
};

type Props = unknown;

interface State {
  dashboard: string;
}

export default class Dashboard extends React.Component<Props, State> {
  private mounted: boolean;

  public constructor(props: Props) {
    super(props);

    this.mounted = false;

    this.state = {
      dashboard: '',
    };
  }

  public componentDidMount = (): void => {
    this.mounted = true;
    this.load().catch(() => { /* pass */ });
  };

  public componentWillUnmount = (): void => {
    this.mounted = false;
  };

  public load = async (): Promise<void> => {
    const user: UserDO = _.get(window.store.getState(), ['user', 'user']);

    // Select custom dashboard for client type user
    if (user && user.type === 'cli') {
      const dashboard1: string = `/dashboard/client_${user.id || ''}.json`;
      const dashboard2: string = `/dashboard/company_${user.area_id || ''}.json`;

      let host: string = '';
      if (config.fbdRootUrl?.startsWith('http')) {
        const furl: URL = new URL(config.fbdRootUrl);
        host = `${furl.protocol}//${furl.hostname}`;
      }

      if (await this.chkFileOnURL(`${host}${dashboard1}`)) {
        this.setState({ dashboard: dashboard1 });
      } else if (await this.chkFileOnURL(`${host}${dashboard2}`)) {
        this.setState({ dashboard: dashboard2 });
      }
    }
  };

  public chkFileOnURL = async (url: string): Promise<boolean> => {
    const result: boolean = await fetch(url, { method: 'HEAD', mode: 'cors' })
      .then((resp: Response) => { return resp.ok; }, () => { return false; })
      .catch(() => { return false; });

    return result;
  }

  public render(): JSX.Element {
    const { dashboard } = this.state;
    const source: string = `${config.fbdRootUrl}#source=${dashboard}`;

    return (
      <div id="content" style={{ width: '99%' }}>
        <WidgetGrid>
          <JarvisWidget
            editbutton={false}
            togglebutton={false}
            colorbutton={false}
            deletebutton={false}
            custombutton={false}
            fullscreenbutton={false}
            height="calc(100vh - 160px)"
          >
            <div className="widget-body">
              <Iframe src={source} />
            </div>
          </JarvisWidget>
        </WidgetGrid>
      </div>
    );
  }
}
